import { css } from 'lit';

export const style = css`
  .error-message-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  fs-icon {
    padding: 0.5em;
  }

  fs-body-text {
    text-align: center;
  }
`;
